import purchaseView from '../../../../components/reimbursement/purchaseView'
import PublicBuill from '../../../../components/reimbursement/js/publicBuill'
import axios from 'axios'
export default {
  components: {
    purchaseView
  },
  data() {
    return {
      treeData: [{
        label: '全部',
        children: []
      }],
      queryData: {
        gys: '',
        jbr: '',
        rq: []
      },
      tableData: [],
      currentPage: 1,
      total: 0,
      limit: 200,
      documentType: 'all',
      role: '',
      /* 弹窗 */
      confirmDialogVisible: false,
      dialogTitle: '',
      cnConfirm: {
        zffs: '',
        ph: ''
      },
      rowData: {},
      /* 查看组件 */
      purchaseShow: false,
      startTime: '',
      sumArr: ['合计', '', '', '', '', '', '', '', '', '', '', '', ''],
      endTime: new Date().format('yyyy-MM') + '-' + (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate())


    }
  },
  created() {
    PublicBuill.setThis(this)
    const data = new Date().format('yyyy')
    var currentMonth = new Date().getMonth() + 1
    this.startTime = data + '-' + currentMonth + '-' + '01'
    this.treeData[0].children = PublicBuill.getBillTree('cg')
    this.role = PublicBuill.getTreeValue(this.treeData[0].children)
    const obj = {}
    obj.label = '全部'
    obj.value = this.role
    this.treeData[0].children.unshift(obj)
    this.findPage()
  },
  methods: {
    Nindex(index) {
      const page = this.currentPage
      const pageSize = this.limit
      return index + 1 + (page - 1) * pageSize
    },
    /* 查询列表数据 */
    findPage() {
      if (!this.role) {
        this.$message.error('该用户缺少数据查看权限！！')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '查询中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        gys: this.queryData.gys ? this.queryData.gys : null,
        lrrname: this.queryData.jbr ? this.queryData.jbr : null,
        documentType: this.documentType === 'all' ? this.role : this.documentType,
        limit: this.limit,
        currentPage: this.currentPage,
        rq: this.startTime ? this.startTime + ' 00:00:00' : null,
        lrrq: this.endTime ? this.endTime + ' 23:59:59' : null
      }
      this.tableData = []
      this.sumArr = ['合计', '', '', '', '', '', '', '', '', '', '', '', '']
      this.$post('/fesback/purchase/getPaidPurchaseData.z', data).then(request => {
        PublicBuill.purchaseJeFormatter(request.data.data)
        this.tableData = request.data.data
        this.total = request.data.count

        const je = PublicBuill.formatAmount(request.data.je.toFixed(2))
        const tgje = PublicBuill.formatAmount(request.data.tgje.toFixed(2))
        const yfk = PublicBuill.formatAmount(request.data.yfk.toFixed(2))
        const qk = PublicBuill.formatAmount(request.data.qk.toFixed(2))
        this.sumArr = ['合计', '', '', '', '', '', je, tgje, yfk, qk, '', '', '']
        loading.close()
      }).catch(res => {
        loading.close()
        this.$message.error(res)
      })

    },
    /* 时间格式化 */
    rqconfirm(value) {
      var month = new Date(value).getMonth()
      var day = new Date(value).getDate()
      if (month <= 9) {
        month = '0' + (month + 1)
      }
      if (day <= 9) {
        day = '0' + day
      }
      return new Date(value).getFullYear() + '-' + month + '-' + day

    },
    /* 分页 */
    handleSizeChange(val) { // 每页多少条
      this.limit = val
      this.findPage()
    },
    handleCurrentChange(val) { // 当前页
      this.currentPage = val
      this.findPage()
    },
    /* 打印 */
    Print(index, row) {
      PublicBuill.cgfksqdPrint(row)
    },
    confirm(index, row) {
      this.rowData = row
      if (row.documentType === 'wzyb') {
        alert(1)
      } else if (row.documentType === 'actuator') {
        this.dialogTitle = '执行器公司付款申请单出纳申请确认'
      } else if (row.documentType === 'ic') {
        this.dialogTitle = '装备公司付款申请单出纳申请确认'
      }
      this.confirmDialogVisible = true
    },
    view(index, row) {
      this.rowData = row
      this.purchaseShow = true
    },
    rqFormatter(row, column, cellValue, index) {
      const arr = row.rq.split('.')
      return arr[0]
    },
    exportPaidPurchase() {
      const loading = this.$loading({
        lock: true,
        text: '请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        gys: this.queryData.gys ? this.queryData.gys : null,
        lrrname: this.queryData.jbr ? this.queryData.jbr : null,
        documentType: this.documentType === 'all' ? this.role : this.documentType,
        rq: this.startTime ? this.startTime + ' 00:00:00' : null,
        lrrq: this.endTime ? this.endTime + ' 23:59:59' : null
      }
      axios.post(
        '/fesback/purchase/exportPaidPurchase.z',
        data,
        {
          responseType: 'blob'
        }
      ).then(res => {
        loading.close()
        const fileName = '已支付采购付款单据' + '.xlsx'
        const blob = new Blob([res.data], { type: 'application/octet-stream' })
        const a = document.createElement('a')
        const href = URL.createObjectURL(blob)
        a.href = href
        a.setAttribute('download', fileName)
        a.click()
        URL.revokeObjectURL(href)
      })
    },
    cnrqFormatter(row, column, cellValue, index) {
      const arr = row.cnqrrq.split('.')
      return arr[0]
    },
    handleClose(done) {
      this.confirmDialogVisible = false
    },
    getSummaries(param) {
      return this.sumArr
    },
    confirmCn() {
      this.rowData
      this.confirmDialogVisible = false
    }

  }

}
// eslint-disable-next-line no-extend-native
Date.prototype.format = function(fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
